// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3RmR7","title":"AfterFrontImage_title__1i0vv"};